namespace GeniuzPOS.InitialData {
    export class PsPanelItemButtonColumns {
        static columnsKey = 'InitialData.PsPanelItemButton';
    }
}
